import { useState, useEffect } from "react";
/**
 * A custom React hook to track and return the current window dimensions.
 *
 * @returns {object} An object containing the window's width and height.
 * @returns {number} return.width The current width of the window in pixels.
 * @returns {number} return.height The current height of the window in pixels.
 */

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
};
